import { ForecastListItem } from '@futrli-sdk/predict';

export enum ForecastType {
  BUDGET = 'budget',
  SCENARIO = 'scenario',
  SCENARIO_WITH_INVOICES = 'scenario-with-invoices'
}

interface PerformanceComparisonFilters {
  comparisonMetric: string;
  currentForecastsIds: string[];
  fromDate: string;
  periodType: string;
}

export type PerformanceComparisonFiltersData = Record<string, PerformanceComparisonFilters>;

type SharedForecastProps = Required<
  Pick<ForecastListItem, 'id' | 'created' | 'modified' | 'owner_id' | 'status' | 'kind' | 'name' | 'forecast_from_date'>
>;
type UnsharedForecastProps = Partial<
  Pick<ForecastListItem, 'is_frozen' | 'is_hidden' | 'include_ai_assumptions' | 'include_unpaid_invoices' | 'checklist'>
>;
export interface OrgOrConForecastListItem extends SharedForecastProps, UnsharedForecastProps {}

export enum ForecastTypeFilterValues {
  ALL = 'all',
  THREE_WAY_FORECASTS = '3_way_forecast',
  P_AND_L_BUDGETS = 'p_and_l_budgets'
}
